export default [
    {
        path: '/dedicated-server',
        name: 'dedicated-server',
        component: () => import('@/views/pages/dedicated-server/DedicatedServerList.vue'),
    }
]
